import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';
import methods from './create_form.methods';


export default {
    components: {
        Sidebar,
        Navbar,
        InactivityModal
    },

    mounted() {
        this.fetch_forms();
        this.getProfileTypes();
        this.fetchPortals();
    },

    data() {
        return ({
            profile_tab_id: this.$route.params.profile_tab_id,
            forms: [],
            form_name: '',
            form_description: '',
            errors: {},
            profile_types: [],
            isSubmitting: false,
            isLoading: false,
            token_exists: false,
            selected_profiles: [],
            form_id: null,
            selected_business_tab: '',
            form_error_message: '',
            initial_selected_profiles: [],
            initial_selected_portals: [],
            selected_forms: [],
            all_selected_forms: false,
            portals: [],
            selected_portals: [],
        });
    },
    methods,
}
